import { Outlet, Link, useNavigate } from "react-router-dom";
import { Suspense, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { setLogout, selectUserData } from "features/user/userSlice";

import { SiderMenu } from "components/menu/SiderMenu";
import { Bread } from "components/menu/Bread";

import { selectActiveProject } from "features/project/projectsSlice";
import { ProjectTypes, parseProjectId } from "service/projects";

const UserDashboard = () => {
  const [collapsed, setCollapsed] = useState(false);
  let navigate = useNavigate();

  let [searchParams] = useSearchParams();
  const projectId = parseProjectId(searchParams.get("project_id"));

  const activeProject = useSelector(selectActiveProject);
  const userData = useSelector(selectUserData);
  const dispatch = useDispatch();

  function handleVerticalMenu() {
    setCollapsed(!collapsed);
  }

  function getProjectLink(project) {
    for (const item of ProjectTypes) {
      if (item.value === project.project_type) {
        return item.url + `?project_id=${ project.id }&project_type=${ project.project_type }&project_name=${ project.name }`;
      }
    }
    return "project_summary/";
  }

  function getUserName() {
    if (userData == null) {
      return "";
    }

    return userData.first_name + " " + userData.last_name;
  }

  function getAvatarUrl() {
    const photo = userData?.photo;
    if (photo && photo !== "photo/url" && photo.startsWith("/")) {
      return photo;
    }
    if (photo && /^https?:\/\//.test(photo)) {
      return photo;
    }
    return "/static/images/users/default-avatar.jpg";
  }

  function generateProjectTitle() {
    if (activeProject == null) {
      return null;
    }

    let prjId = parseProjectId(activeProject.id);
    if (projectId != null && projectId !== prjId) {
      return null;
    }

    return (
      <div>
        Current Project:
        {/* <Link to={getProjectLink(activeProject)}>{activeProject.name}</Link> */}
        {/* <a href="#" onClick={()=>{
          let url = getProjectLink(activeProject);
          console.log("to=>", url);
          navigate(url);
        }}>{activeProject.name}</a> */}
        <a href={getProjectLink(activeProject)}><span style={{ marginLeft: '4px' }}>{activeProject.name}</span></a>
      </div>
    );
  }

  return (
    <div id="layout-wrapper" className={collapsed ? "vertical-collpsed" : ""}>
      <div id="page-topbar">
        <div className="navbar-header">
          <div>
            <Bread />
          </div>
          <div className="project-name">{generateProjectTitle()}</div>
          <div className="d-flex align-items-center">
            <img
              src="/static/images/home.png"
              alt="home"
              width={26}
              height={26}
              style={{ cursor: 'pointer', marginRight: '15px' }}
              onClick={() => window.location = "/"}
            />
            <div className="dropdown d-inline-block">
              <button
                type="button"
                className="btn header-item waves-effect"
                id="page-header-user-dropdown"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <img
                  className="rounded-circle header-profile-user"
                  src={getAvatarUrl()}
                  alt="Header Avatar"
                  onError={(e) => {
                    e.currentTarget.src = "/static/images/users/default-avatar.jpg";
                  }}
                />
                <span className="d-none d-xl-inline-block ms-1 fw-medium">
                  {getUserName()}
                </span>
                <i className="uil-angle-down d-none d-xl-inline-block"></i>
              </button>
              <div className="dropdown-menu dropdown-menu-end">
                <Link className="dropdown-item" to="/profile/">
                  <i className="uil uil-user-circle align-middle text-muted me-1"></i>
                  <span className="align-middle">View Profile</span>
                </Link>
                <Link className="dropdown-item" to="/account/change_password/">
                  <i className="align-middle text-muted me-1 mdi mdi-key"></i>
                  <span className="align-middle">Change Password</span>
                </Link>
                <div className="dropdown-divider"></div>
                <Link
                  className="dropdown-item text-danger"
                  onClick={() => {
                    dispatch(setLogout(null));
                  }}
                  to="/logout/"
                >
                  <i className="align-middle me-1 text-danger mdi mdi-logout-variant"></i>
                  <span className="align-middle">Log Out</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <aside className="vertical-menu">
        <div className="navbar-brand-box">
          <div className="logo">
            <img
              src="/static/images/logo-text2.png"
              alt="logo"
              onClick={() => window.location = "/"}
              style={{ cursor: 'pointer' }}
            />
          </div>
        </div>
        <div className="menu-btn-wrapper">
          <div onClick={handleVerticalMenu} className="vertical-menu-btn">
            <i className="mennu-outline"></i>
          </div>
        </div>
        <div data-simplebar className="sidebar-menu-scroll">
          <div id="sidebar-menu">{<SiderMenu />}</div>
        </div>
      </aside>

      <main className="main-content">
        <Suspense fallback="Loading...">
          <Outlet />
        </Suspense>
        <footer className="footer"></footer>
      </main>
    </div>
  );
};

export default UserDashboard;
